// athena.ts
// Service function for retrieving authentication tokens from the Athena API.
// Provides token exchange operation for OAuth2/EHR launch flows.

import axios from "@/utils/axios";
import { TokenResponse } from "@/types/auth";

/**
 * Exchanges an authorization code for an authentication token.
 * @param code - The authorization code to exchange
 * @returns The token response object
 */
export const getToken = async ({ code }: { code: string }) => {
  const { data } = await axios.get<TokenResponse>("/api/access/token", {
    params: {
      code
    }
  });

  return data;
};
